const LOCAL_AUTH_TOKEN_PREFIX = "core-local-auth:";
const LOCAL_AUTH_USER_KEY = "coreLocalAuthUser";

export const isLocalAuthToken = (token) =>
  typeof token === "string" && token.startsWith(LOCAL_AUTH_TOKEN_PREFIX);

export const getStoredLocalAuthUser = () => {
  try {
    const raw = localStorage.getItem(LOCAL_AUTH_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearLocalAuthSession = () => {
  localStorage.removeItem(LOCAL_AUTH_USER_KEY);
  const token = localStorage.getItem("token");
  if (isLocalAuthToken(token)) {
    localStorage.removeItem("token");
  }
};

export const setLocalAuthSession = (user) => {
  const sessionUser = {
    ...user,
    organization: null,
    user_active_organization: null,
    organizationuser: null,
    metadata: [],
    is_core_platform: true,
  };
  localStorage.setItem(
    "token",
    `${LOCAL_AUTH_TOKEN_PREFIX}${user?.application_user_id ?? "default"}`
  );
  localStorage.setItem(LOCAL_AUTH_USER_KEY, JSON.stringify(sessionUser));
};
